import React from "react";
import CellphoneFrame from "../Assets/Images/CellphoneFrame.png";

import LoginForm from "../Assets/Images/login_form.svg";
import CsLogo from "../Assets/Images/church-streaming-app-logo-white.png"

const IphoneScreen = (props) => {
  const { backgroundBase, SecundaryBackground, btnColor, btnFont, font, recoverPass, fullLogoBlob } = props;
  const styles = {
    container: {
      position: "relative",
      maxWidth: "234px",
      minWidth: "234px",
    },
    imageOverlay: {
      width: "100%",
      height: "auto",
      position: "absolute",
      left: 0
    },
    containerFrame: {
      backgroundColor: backgroundBase || "#F0F0F4",
      color: font || "#F0F0F4",
    },
    text: {
      fontSize: "12px",
    },
    description: {
      display: "flex",
      justifyContent: "center",
    },
    topLogin: {
      backgroundColor: SecundaryBackground || "#999",
    },
    tagline: {
      color: font || "#FFF",
    },
    signUpBtn: {
      color: btnFont || "#FFF",
      backgroundColor: btnColor || "#999",
    },
    recoverPassLink: {
      color: recoverPass || "#999",
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.container}>
        <img src={CellphoneFrame} style={styles.imageOverlay} />
        <div style={styles.containerFrame} className="internal-phone-frame">
          <div className="top-app-demo" style={styles.topLogin}>
            <img className="client-full-logo" src={fullLogoBlob || CsLogo} />
            <h5 className="logo-tagline" style={styles.topLogin}>Live Stream Control</h5>
          </div>
          <div className="bottom-app-demo">
            <img src={LoginForm} className="fake-form-demo" />
            <div className="login-btn-demo" style={styles.signUpBtn}>
              Sign In
            </div>
            <h6 style={styles.recoverPassLink}><b>Recover</b> Password</h6>
          </div>
        </div>
      </div>
      <h4 className="phone-label" style={styles.description}>{props.description}</h4>
    </div>
  );
};

export default IphoneScreen;
